import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { ReceiptStatus } from './api';

/**
 * Three states, and only one of them is still work.
 *
 * Green for posted rather than grey: a posted receipt is not "finished with" the way a closed order
 * is — it is the moment stock appeared, and it is the row somebody goes looking for when a count
 * disagrees next week.
 */
const COLOURS: Record<ReceiptStatus, string> = {
  open: 'blue',
  posted: 'green',
  cancelled: 'gray',
};

export function ReceiptStatusBadge({ status }: { status: ReceiptStatus }) {
  const { t } = useTranslation();
  return (
    <Badge color={COLOURS[status] ?? 'gray'} variant="light">
      {t(`receipts.statuses.${status}`)}
    </Badge>
  );
}
